import { callApi } from "Apis";
import { BUSINESS_CATEGORYURL } from "helpers/constant";
// business category list api...
export async function getBusinessCategoryListApi(data) {
  try {
    const response = await callApi({ url: BUSINESS_CATEGORYURL.LIST, body: data, method: "POST" });
    return response;
  } catch (error) {
    throw error;
  }
}
// business category add api...
export async function addBusinessCategoryApi(data) {
  try {
    const response = await callApi({ url: BUSINESS_CATEGORYURL.ADD, body: data, method: "POST" });
    return response;
  } catch (error) {
    throw error;
  }
}

// business category edit api...
export async function getBusinessCategoryDataByIdApi(id) {
  try {
    const response = await callApi({ url: BUSINESS_CATEGORYURL.GET(id), method: "GET" });
    return response;
  } catch (error) {
    throw error;
  }
}

// business category update api...
export async function updateBusinessCategoryDataApi(data) {
  try {
    const response = await callApi({ url: BUSINESS_CATEGORYURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (error) {
    throw error;
  }
}

// business category delete api...
export async function deleteBusinessCategoryDataApi(id) {
  try {
    const response = await callApi({ url: BUSINESS_CATEGORYURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (error) {
    throw error;
  }
}
